export default {
  apiRoot: process.env.REACT_APP_API_ROOT
};
